var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.component},[_c('base-bodytext',{class:_vm.$style.body,attrs:{"text":_vm.item.body}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }